import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';
import { PageLoader } from '@/components/shared/PageLoader';

const Assets = lazy(() => import('@/pages/Assets'));

const assetsSearchSchema = z.object({
  search: z.string().optional(),
  tab: z.enum(['all', 'templates', 'sops', 'downloads']).optional(),
  pillar: z.enum(['finance', 'operations', 'management', 'marketing', 'sales', 'culture']).optional(),
});

function AssetsListRoute() {
  const search = Route.useSearch();
  return (
    <Suspense fallback={<PageLoader />}>
      <Assets routeSearch={search} />
    </Suspense>
  );
}

export const Route = createFileRoute('/assets/')({
  validateSearch: assetsSearchSchema,
  component: AssetsListRoute,
});
